import * as Types from '@findy-code/yuffie/graphql';

import { gql } from '@apollo/client';
export type FetchJobDescriptionDetailCompanyInterviewFragment = { __typename?: 'CompanyInterview', id: number, alias: string, title?: string | null, thumbnailUrl?: string | null, publishedAt?: string | null };

export type FetchJobDescriptionDetailFindyToolsArticleFragment = { __typename?: 'FindyToolsArticle', id: number, title: string, articleUrl: string, thumbnailUrl: string, publishedAt?: string | null };

export type TeamPlusAwardFragment = { __typename?: 'CompanyTeamPlusAward', label: string };

export type JobDescriptionCompanyAiUsageFragment = { __typename?: 'CompanyAiUsage', isUsingAi: boolean, comment?: string | null, latestUpdatedAt: string, companyAiUsageAnswers: Array<{ __typename?: 'CompanyAiUsageAnswer', companyAiUsageAnswerOption: { __typename?: 'CompanyAiUsageAnswerOption', label: string } }>, companyAiUsageSkills: Array<{ __typename?: 'CompanyAiUsageSkill', skill: { __typename?: 'Skill', id: number, name: string } }> };

export const FetchJobDescriptionDetailCompanyInterviewFragmentDoc = gql`
    fragment FetchJobDescriptionDetailCompanyInterview on CompanyInterview {
  id
  alias
  title
  thumbnailUrl
  publishedAt
}
    `;
export const FetchJobDescriptionDetailFindyToolsArticleFragmentDoc = gql`
    fragment FetchJobDescriptionDetailFindyToolsArticle on FindyToolsArticle {
  id
  title
  articleUrl
  thumbnailUrl
  publishedAt
}
    `;
export const TeamPlusAwardFragmentDoc = gql`
    fragment TeamPlusAward on CompanyTeamPlusAward {
  label
}
    `;
export const JobDescriptionCompanyAiUsageFragmentDoc = gql`
    fragment JobDescriptionCompanyAiUsage on CompanyAiUsage {
  isUsingAi
  comment
  latestUpdatedAt
  companyAiUsageAnswers {
    companyAiUsageAnswerOption {
      label
    }
  }
  companyAiUsageSkills {
    skill {
      id
      name
    }
  }
}
    `;